var map = {
	"./2025_final/compete-Pre.vue": [
		"f5CY",
		0,
		41
	],
	"./2025_final/index.vue": [
		"I4Go",
		0,
		8
	],
	"./2025_final/login.vue": [
		"pYkS",
		0,
		27
	],
	"./2025_final/signup.vue": [
		"75YN",
		0,
		10
	],
	"./2025_final/userIndex.vue": [
		"mkEJ",
		0,
		2
	],
	"./2025_global/compete-Pre.vue": [
		"LB9l",
		12
	],
	"./2025_global/index.vue": [
		"hPpc",
		0,
		34
	],
	"./2025_global/login.vue": [
		"2uJq",
		0,
		16
	],
	"./2025_global/rank.vue": [
		"eOdM",
		20
	],
	"./2025_global/userIndex.vue": [
		"LYoU",
		0,
		19
	],
	"./2026/compete-Pre.vue": [
		"i+Bo",
		0,
		43
	],
	"./2026/confirmInfomation.vue": [
		"lrly",
		0,
		28
	],
	"./2026/index.vue": [
		"R/Hm",
		0,
		11
	],
	"./2026/login.vue": [
		"1k9y",
		0,
		33
	],
	"./2026/signup.vue": [
		"9yGk",
		0,
		13
	],
	"./2026/userIndex.vue": [
		"97/O",
		0,
		1
	],
	"./SCSSN2024/compete-Pre.vue": [
		"gEka",
		0,
		9
	],
	"./SCSSN2024/index.vue": [
		"Fpry",
		0,
		75
	],
	"./SCSSN2024/login.vue": [
		"Pm2R",
		0,
		39
	],
	"./SCSSN2024/signup.vue": [
		"/TZd",
		0,
		74
	],
	"./SCSSN2024/userIndex.vue": [
		"GFYm",
		0,
		73
	],
	"./aimsity/comming.vue": [
		"h0SR",
		25
	],
	"./aimsity/index.vue": [
		"GClI",
		0,
		31
	],
	"./aimsity/main.vue": [
		"3bW9",
		0,
		72
	],
	"./aimsity/pay.vue": [
		"Bzyq",
		17
	],
	"./cngef/index.vue": [
		"z6aL",
		46
	],
	"./cngef/main.vue": [
		"wJVF",
		0,
		71
	],
	"./cngef/template/index.vue": [
		"nO65",
		0,
		70
	],
	"./cngef/template/login.vue": [
		"95SM",
		0,
		69
	],
	"./cngef/template/main.vue": [
		"0WZM",
		0,
		68
	],
	"./cngef/template/signup.vue": [
		"KZ10",
		0,
		67
	],
	"./cngef/template/userIndex.vue": [
		"B8Yp",
		0,
		7
	],
	"./mgtv/index.vue": [
		"sAtp",
		0,
		45
	],
	"./mgtv/main.vue": [
		"UgKv",
		0,
		66
	],
	"./myc2025/index.vue": [
		"ExFx",
		0,
		15
	],
	"./myc2025/main.vue": [
		"/J2m",
		0,
		65
	],
	"./teacher/compete-Pre.vue": [
		"8YMq",
		0,
		3
	],
	"./teacher/index.vue": [
		"QVfe",
		0,
		21
	],
	"./teacher/login.vue": [
		"MDYz",
		0,
		30
	],
	"./teacher/signup.vue": [
		"u8SZ",
		0,
		35
	],
	"./teacher/user-groups.vue": [
		"qOUf",
		0,
		5
	],
	"./teacher/userIndex.vue": [
		"nwdp",
		0,
		29
	],
	"./teacher2/compete-Pre.vue": [
		"FiU2",
		4
	],
	"./teacher2/index.vue": [
		"l6PY",
		0,
		40
	],
	"./teacher2/login.vue": [
		"FMyQ",
		0,
		14
	],
	"./teacher2/userIndex.vue": [
		"GU93",
		0,
		37
	],
	"./teacherExam2/compete-Pre.vue": [
		"Q5pc",
		0,
		18
	],
	"./teacherExam2/index.vue": [
		"bWdF",
		0,
		44
	],
	"./teacherExam2/login.vue": [
		"wtOt",
		0,
		32
	],
	"./teacherExam2/signup.vue": [
		"otj1",
		0,
		36
	],
	"./teacherExam2/userIndex.vue": [
		"LFcS",
		0,
		38
	],
	"./template/index.vue": [
		"xniI",
		0,
		64
	],
	"./template/login.vue": [
		"7oy6",
		0,
		63
	],
	"./template/main.vue": [
		"oBn2",
		0,
		62
	],
	"./template/signup.vue": [
		"IvqQ",
		0,
		61
	],
	"./template/userIndex.vue": [
		"mpjO",
		0,
		6
	],
	"./vn/index.vue": [
		"gLqF",
		60
	],
	"./wrc/compete-Pre.vue": [
		"e0sD",
		0,
		59
	],
	"./wrc/index.vue": [
		"Ri6R",
		0,
		58
	],
	"./wrc/template/index.vue": [
		"qhIX",
		0,
		57
	],
	"./wrc/template/login.vue": [
		"riGw",
		0,
		56
	],
	"./wrc/template/main.vue": [
		"t8lS",
		0,
		55
	],
	"./wrc/template/signup.vue": [
		"FAZy",
		0,
		54
	],
	"./wrc/template/userIndex.vue": [
		"Vpdc",
		0,
		53
	],
	"./wrc_learn/compete-Pre.vue": [
		"fkZr",
		0,
		52
	],
	"./wrc_learn/index.vue": [
		"AYWc",
		0,
		51
	],
	"./wrc_learn/login.vue": [
		"vhSN",
		0,
		50
	],
	"./wrc_learn/signup.vue": [
		"RN08",
		0,
		49
	],
	"./wrc_learn/userIndex.vue": [
		"2k8W",
		0,
		26
	],
	"./wrc_malaysia/index.vue": [
		"pi4A",
		0,
		24
	],
	"./wrc_malaysia/main.vue": [
		"LWL3",
		0,
		48
	],
	"./wrc_singapore/index.vue": [
		"hFs4",
		0,
		42
	],
	"./wrc_singapore/main.vue": [
		"S+bj",
		0,
		47
	],
	"./www/index.vue": [
		"o8Ce",
		0,
		23
	],
	"./www/main.vue": [
		"/lEH",
		0,
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "kPVm";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/contest lazy ^\.\/.*\.vue$
// module id = kPVm
// module chunks = 78